import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(sagasPizarra);

import { all } from 'redux-saga/effects';
import watchNotificarCambiosPizarra from './watch-notificar-cambios-pizarra'; // import {activarEditorPizarraLibro, guardarPizarraLibro, desactivarEditorPizarraLibro, borrarPizarraLibro } from './pizarra-libro';
// import {activarEditorPizarraVentana, guardarPizarraVentana, desactivarEditorPizarraVentana, borrarPizarraVentana } from './pizarra-ventana';
// import {
//     ACTIVAR_EDITOR_PIZARRA,
//     DESACTIVAR_EDITOR_PIZARRA
// } from '../../../actions'
// import { NOTIFICAR_CAMBIOS, SELECCIONAR_HERRAMIENTA } from '../../../pizarra/actions'
// import { HERRAMIENTA_ELIMINAR_DIBUJO } from '../../../pizarra/constantes'
// import * as selectorsVentana from '../../../pantalla-ventana/selectors'
// import { getEditorActivo } from '../../../pizarra/selectors'
// import { PRIMERA_VENTANA_ID, SEGUNDA_VENTANA_ID } from '../../constantes'

/** Devuelve true si hay alguna ventana visible */
// function* algunaVentanaVisible() {
//     const primeraVentanaVisible = yield select(selectorsVentana.getAbierta, PRIMERA_VENTANA_ID);
//     const segundaVentanaVisible = yield select(selectorsVentana.getAbierta, SEGUNDA_VENTANA_ID);
//     return primeraVentanaVisible || segundaVentanaVisible;
// }
// function* watchActivarEditorPizarra() {
//     yield takeLatest(ACTIVAR_EDITOR_PIZARRA, activarEditorPizarra);
// }
// function* activarEditorPizarra() {
//     const editorActivo = yield select(getEditorActivo);
//     if (editorActivo) {
//         return;
//     }
//     /** activar pizarra */
//     const enVentana = yield call(algunaVentanaVisible);
//     if (enVentana) {
//         yield* activarEditorPizarraVentana();
//     } else {
//         yield* activarEditorPizarraLibro();
//     }
// }
// function* desactivarEditorPizarra() {
//     const editorActivo = yield select(getEditorActivo);
//     if (!editorActivo) {
//         return;
//     }
//     const enVentana = yield call(algunaVentanaVisible);
//     if (enVentana) {
//         yield call(desactivarEditorPizarraVentana);
//     } else {
//         yield call(desactivarEditorPizarraLibro);
//     }    
// }
// function* watchDesactivarEditorPizarra() {    
//     yield takeLatest(DESACTIVAR_EDITOR_PIZARRA, desactivarEditorPizarra);
// }
// function* guardarPizarra() {
//     const primeraVentanaVisible = yield select(selectorsVentana.getAbierta, PRIMERA_VENTANA_ID);
//     const segundaVentanaVisible = yield select(selectorsVentana.getAbierta, SEGUNDA_VENTANA_ID);
//     if (primeraVentanaVisible || segundaVentanaVisible) {
//         yield call(guardarPizarraVentana);
//         return;
//     }
//     yield call(guardarPizarraLibro);
// }
// function* watchNotificarCambiosPizarra() {
//     yield takeLatest(NOTIFICAR_CAMBIOS, guardarPizarra);
// }
// function* borrarPizarra() {
//     const primeraVentanaVisible = yield select(selectorsVentana.getAbierta, PRIMERA_VENTANA_ID);
//     const segundaVentanaVisible = yield select(selectorsVentana.getAbierta, SEGUNDA_VENTANA_ID);
//     if (primeraVentanaVisible || segundaVentanaVisible) {
//         yield call(borrarPizarraVentana);
//         return;
//     }
//     yield call(borrarPizarraLibro); 
// }
// function* watchBorrarPizarra() {
//     yield takeLatest( 
//         action => (action.type === SELECCIONAR_HERRAMIENTA && action.herramienta === HERRAMIENTA_ELIMINAR_DIBUJO),
//         borrarPizarra
//     )
// }

function sagasPizarra() {
  return _regeneratorRuntime.wrap(function sagasPizarra$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([// watchActivarEditorPizarra(),
          watchNotificarCambiosPizarra()] // watchDesactivarEditorPizarra(),  
          // watchBorrarPizarra()      
          );

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

export default sagasPizarra;